import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Wrp from '../Wrp/Wrp';
import {
    // setErrorListAction,
    clearErrorListAction,
    // clearErrorElementsListAction,
    // setErrorDetailListAction,
    showErrorDetailsAction
} from '../../store/actions/ErrorSetupAction';

class ViewPort extends Component {

    componentWillMount = () => {
        this.props.clearErrorListAction([])
    }

    render () {
        const {backgroundColor,overflowY,children,errorsDetailList} = this.props;
        // let viewScrollCss = {};
        // if(overflowY!==null){
        //     viewScrollCss = {
        //         overflowY:overflowY
        //     }
        // }
        let viewPortCss = {};
        if(overflowY!==null){
            viewPortCss = {
                background:backgroundColor
            }
        }
        //console.log('this.props.params',this.props.match)
        return (
            <>
                {
                    this.props.isErrorModalOpen ===true && this.props.isErrorElementsModalOpen === false?
                    <div className="">
                        <div className="flyout d-flex cursor-pointer viewMoreToggle_messagesInfo ">
                           <div className="d-flex cursor-pointer quick-sidebar-toggler ">
                              <div className="crm_Warning animated fadeInLeft" data-notify="container" onClick={()=>this.props.showErrorDetailsAction()}> 
                                 <span data-notify="icon">{errorsDetailList.warningErrorListCount} </span>
                                 <span data-notify="title"> Warning </span> 
                              </div>            
                              <div className="crm_Info animated fadeInLeft" data-notify="container" onClick={()=>this.props.showErrorDetailsAction()}>             
                                 <span data-notify="icon"> {errorsDetailList.infoErrorListCount} </span>
                                 <span data-notify="title"> Info </span>            
                              </div>
                              <div className="crm_Error animated fadeInLeft" data-notify="container" onClick={()=>this.props.showErrorDetailsAction()}> 
                                 <span data-notify="icon"> {errorsDetailList.errorErrorListCount} </span>
                                 <span data-notify="title"> Error </span>
                              </div>
                           </div>
                           
                        </div>
                        <div className="opener"> 
                           <span className="toggle active"></span>
                        </div>
                     </div>
                    :
                    <></>
                }

            <div className="viewport" style={viewPortCss}>

                

                <div className="view view-xl" style={{overflow:'inherit'}}>
                    {children}
                </div>                

            </div>
            </>
        )
   }
}
ViewPort.defaultProps = {
    backgroundColor: null,
    overflowY:null,
    innerViewStyle:{overflowX:'hidden' }
}

const mapDispatchToProps = dispatch => {
    return {      
      showErrorDetailsAction:()=>dispatch(showErrorDetailsAction()),
      clearErrorListAction:(arr)=>dispatch(clearErrorListAction(arr)),
    };
  }
const mapStateToProps = (state) => { 
    return {    
        isErrorModalOpen:state.ErrorSetupReducer.isErrorModalOpen,    
        isErrorElementsModalOpen:state.ErrorSetupReducer.isErrorElementsModalOpen,   
        errorsList:state.ErrorSetupReducer.errorsList,
        errorsDetailList:state.ErrorSetupReducer.errorsDetailList,
        showErrorDetails:state.ErrorSetupReducer.showErrorDetails,
    };
}

export default
    connect(
      mapStateToProps, 
      mapDispatchToProps
    )(ViewPort);

//export default ViewPort;  




